

import * as THREE from 'three';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

const canvas = document.getElementById('nt-gl');
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
let ready = false;
const small = matchMedia('(max-width:760px)').matches;
const far = !document.body.classList.contains('bbc-nt');
const bare = /\btpl-(collection|search|list-collections)\b/.test(document.body.className);
const STORY = document.documentElement.classList.contains('nt-story'), SP = STORY ? 2.2 : 1;            
if (far) canvas.classList.add('far');
let renderer;
try { renderer = new THREE.WebGLRenderer({ canvas, antialias:!small, powerPreference:'low-power' }); } catch (e) { canvas.style.display = 'none'; throw e; }
renderer.setPixelRatio(Math.min(small ? 1.25 : 2, devicePixelRatio));
renderer.setClearColor(0xffffff, 1);
function applyTheme(t){ const b = t === "black", c = b ? 0x0b0b0b : 0xffffff; renderer.setClearColor(c, 1); if (scene.fog) scene.fog.color.setHex(c); clay.color.setHex(b ? 0x5a5a5a : 0xcfcfcf); chrome.color.setHex(b ? 0x8a8a8a : 0xd8d8d8); if (reduce) renderer.render(scene, camera); }
renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
const scene = new THREE.Scene();
scene.environment = new THREE.PMREMGenerator(renderer).fromScene(new RoomEnvironment(), .04).texture;
scene.fog = new THREE.Fog(0xffffff, 10, 80);
const camera = new THREE.PerspectiveCamera(55, 1, .1, 200);
scene.add(new THREE.HemisphereLight(0xffffff, 0xdedede, .9));
const sun = new THREE.DirectionalLight(0xffffff, 1.4); sun.position.set(4, 6, 5); scene.add(sun);

let seed = 21; const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;


function starShape(R, r, n = 5) {   
  const v = []; for (let i = 0; i < n*2; i++) { const a = Math.PI/2 + i*Math.PI/n, rr = i%2 ? r : R; v.push(new THREE.Vector2(Math.cos(a)*rr, Math.sin(a)*rr)); }
  const sh = new THREE.Shape(), k = .14, N = v.length;
  for (let i = 0; i < N; i++) { const c = v[i], pr = v[(i+N-1)%N], nx = v[(i+1)%N];
    const a1 = c.clone().lerp(pr, k), a2 = c.clone().lerp(nx, k);
    i ? sh.lineTo(a1.x, a1.y) : sh.moveTo(a1.x, a1.y); sh.quadraticCurveTo(c.x, c.y, a2.x, a2.y); }
  sh.closePath(); return sh; }
function sparkShape(R) { const sh = new THREE.Shape(), k = .14; for (let i = 0; i < 4; i++) { const a = Math.PI/2 + i*Math.PI/2, b = a + Math.PI/2, L1 = R*(i%2 ? .7 : 1), L2 = R*((i+1)%2 ? .7 : 1); i ? sh.lineTo(Math.cos(a)*L1, Math.sin(a)*L1) : sh.moveTo(Math.cos(a)*L1, Math.sin(a)*L1); sh.quadraticCurveTo(Math.cos(a+Math.PI/4)*R*k, Math.sin(a+Math.PI/4)*R*k, Math.cos(b)*L2, Math.sin(b)*L2); } return sh; }
const ext = (sh, d, bv) => { const g = new THREE.ExtrudeGeometry(sh, { depth:d, bevelEnabled:true, bevelThickness:bv, bevelSize:bv*.8, bevelSegments:14, curveSegments:28 }); g.center(); return g; };   
const solid = ext(starShape(1, .45), .28, .12);
const frameSh = starShape(1, .45); frameSh.holes.push(starShape(.72, .3)); const outline = ext(frameSh, .16, .06);   
const spark = ext(sparkShape(1), .12, .06);
const dia = (() => { const sh = new THREE.Shape(); sh.moveTo(0,1); sh.lineTo(.62,0); sh.lineTo(0,-1); sh.lineTo(-.62,0); sh.closePath(); return ext(sh, .3, .1); })();   
const clay = new THREE.MeshStandardMaterial({ color:0xcfcfcf, roughness:.38, metalness:.05 });
const chrome = new THREE.MeshStandardMaterial({ color:0xd8d8d8, roughness:.22, metalness:.85, envMapIntensity:1.6 });


const pts = []; for (let i = 0; i < 14; i++) { const t = i/14*Math.PI*2; pts.push(new THREE.Vector3(Math.sin(t)*70 + Math.sin(t*3)*14, Math.sin(t*2)*16, Math.cos(t)*70 + Math.cos(t*2)*12)); }
const curve = new THREE.CatmullRomCurve3(pts, true, 'centripetal');
const SEG = 1200, frames = curve.computeFrenetFrames(SEG, true), P = curve.getSpacedPoints(SEG);

const _p = new THREE.Vector3(), _n = new THREE.Vector3(), _b = new THREE.Vector3();
const at = u => { const f = ((u % 1) + 1) % 1 * SEG, i = Math.floor(f) % SEG, j = (i + 1) % SEG, w = f - Math.floor(f);
  return { p:_p.copy(P[i]).lerp(P[j], w).clone(), n:_n.copy(frames.normals[i]).lerp(frames.normals[j], w).normalize().clone(), b:_b.copy(frames.binormals[i]).lerp(frames.binormals[j], w).normalize().clone() }; };


const items = [];
function group(geo, mat, count, place) { count = small ? Math.ceil(count*.85) : count; if (far) count = Math.ceil(count*.8); if (STORY) count = Math.ceil(count*.55);  const m = new THREE.InstancedMesh(geo, mat, count); m.frustumCulled = false; m.instanceMatrix.setUsage(THREE.DynamicDrawUsage); scene.add(m); for (let i = 0; i < count; i++) items.push({ m, i, ...place(i) }); return m; }
const tube = () => ({ u:rnd(), ang:rnd()*Math.PI*2, r:3 + Math.pow(rnd(), .8)*10, rot:new THREE.Euler(rnd()*6, rnd()*6, rnd()*6), spin:new THREE.Vector3((rnd()-.5)*.6, (rnd()-.5)*.6, (rnd()-.5)*.6), sp:.6 + rnd()*.8 });
group(solid, clay, 120, () => ({ ...tube(), sc:.35 + rnd()*.75 }));
group(spark, clay, 120, () => ({ ...tube(), sc:.3 + rnd()*.7 }));
group(dia, clay, 40, () => ({ ...tube(), sc:.35 + rnd()*.6 }));
group(dia, chrome, 14, () => ({ ...tube(), sc:.3 + rnd()*.4 }));
group(solid, chrome, 24, () => ({ ...tube(), sc:.25 + rnd()*.4 }));

const CH = small ? 5 : 9, PER = 5, heads = Array.from({length:CH}, tube);
group(outline, clay, CH*PER, i => { const h = heads[Math.floor(i/PER) % CH], k = i % PER; return { ...h, u:h.u - k*.006, sc:1.05*Math.pow(.74, k), rot:new THREE.Euler(h.rot.x, h.rot.y, h.rot.z + k*.4) }; });


const shopEl = document.querySelector('.nt-tabs') || document.body;
const meteor = document.getElementById('nt-meteor'), mhead = document.getElementById('nt-mhead');

let dragging = false;
const seek = e => { const r = meteor.getBoundingClientRect(), q = Math.min(1, Math.max(0, (e.clientY - r.top)/r.height)); scrollTo(0, q*(document.documentElement.scrollHeight - innerHeight)); };
meteor.addEventListener('pointerdown', e => { dragging = true; meteor.setPointerCapture(e.pointerId); seek(e); });
meteor.addEventListener('pointermove', e => dragging && seek(e));
meteor.addEventListener('pointerup', () => dragging = false);
const scrollY_ = () => scrollY;
function resize() { const w = innerWidth, h = innerHeight; renderer.setSize(w, h, false); camera.aspect = w/h; camera.updateProjectionMatrix(); if (reduce && ready) renderer.render(scene, camera); }
addEventListener('resize', resize); resize();


const INTRO = !!window.__ntIntro && !reduce && !far;
const introT0 = performance.now(), GATHER = 2.55;
let introDone = !INTRO, flashed = false;
const camR = new THREE.Vector3(), camUp = new THREE.Vector3(), camF = new THREE.Vector3(), CEN = new THREE.Vector3(), PJ = new THREE.Vector3();
const flash = document.getElementById('nt-flash');
function introEnd(){ if (introDone) return; introDone = true; applyTheme(document.documentElement.dataset.theme || 'white');
  window.__ntIntroEnd && window.__ntIntroEnd(); if (flash) { flash.classList.add('go'); setTimeout(() => flash.classList.add('out'), 550); setTimeout(() => flash.remove(), 2200); } }
if (INTRO) { addEventListener('nt-intro-skip', introEnd); for (const o of items) { o.dl = rnd()*.22; o.fx = rnd(); o.fa = rnd()*6.283; o.show = rnd() < (small ? .5 : .32); } }   
let camU = 0, drift = 0, lastY = scrollY_(), vel = 0, last = performance.now();
const M = new THREE.Matrix4(), Q = new THREE.Quaternion(), S = new THREE.Vector3(), V = new THREE.Vector3(), E = new THREE.Euler();
function frame(now) {
  const dt = Math.min(.05, (now - last)/1000); last = now;
  const time = now/1000, y = scrollY_();
  const journey = Math.max(200, shopEl.getBoundingClientRect().top + scrollY - innerHeight*.35), p = Math.min(1, Math.max(0, y/journey));
  vel += ((y - lastY) - vel)*.08; lastY = y;
  const energy = Math.min(1, Math.abs(vel)/50);
  if (!reduce) drift += dt*.0016*SP;                            
  const target = drift + p*.32 + Math.max(0, y - journey)*.00035;                              
  camU += (target - camU)*.06;                 
  const c = at(camU), ahead = at(camU + .012);
  camera.position.copy(c.p).addScaledVector(c.n, Math.sin(time*.3)*.5).addScaledVector(c.b, Math.cos(time*.25)*.4);
  camera.up.copy(c.n).lerp(c.b, .5 + .5*Math.sin(camU*12)).normalize();   
  camera.lookAt(ahead.p);
  if (!introDone) { camera.updateMatrixWorld(); camR.setFromMatrixColumn(camera.matrixWorld, 0); camUp.setFromMatrixColumn(camera.matrixWorld, 1); camera.getWorldDirection(camF); CEN.copy(camera.position).addScaledVector(camF, 14);
    const it = (now - introT0)/1000;
    if (it > GATHER && !flashed) { flashed = true; if (flash) flash.classList.add('go'); setTimeout(introEnd, 420); } }

  if (!bare) {
  for (const o of items) {
    if (!reduce) { o.u -= dt*.0009*o.sp*(1 + energy*3)*SP; o.rot.x += o.spin.x*dt*SP; o.rot.y += o.spin.y*dt*SP; o.rot.z += o.spin.z*dt*(1 + energy*2)*SP; }
    if (STORY && introDone) { const W = .075, b = camU - .003; o.u = b + (((o.u - b) % W) + W) % W; }
    const f = at(o.u), a = o.ang + time*.03;
    V.copy(f.p).addScaledVector(f.n, Math.cos(a)*o.r).addScaledVector(f.b, Math.sin(a)*o.r);
    if (!introDone) {                                          
      const it = (now - introT0)/1000, q = Math.min(1, Math.max(0, (it - .2 - o.dl)/2.15)), e = .5 - .5*Math.cos(Math.PI*q);   
      const k = 7.5*(1 + o.fx*.55)*(1 - e), an = o.fa + e*1.7;   
      V.copy(CEN).addScaledVector(camR, Math.cos(an)*k).addScaledVector(camUp, Math.sin(an)*k*1.2).addScaledVector(camF, (o.fx - .5)*12*(1 - e));
      E.set(o.rot.x + (1 - e)*2.5, o.rot.y + (1 - e)*2, o.rot.z); Q.setFromEuler(E); S.setScalar(!o.show || q >= 1 ? 0 : o.sc*(1 - .7*e));
      o.m.setMatrixAt(o.i, M.compose(V, Q, S)); continue;
    }
    Q.setFromEuler(o.rot); S.setScalar(o.sc);
    o.m.setMatrixAt(o.i, M.compose(V, Q, S));
  }
  for (const m of new Set(items.map(o => o.m))) m.instanceMatrix.needsUpdate = true;
  }
  canvas.classList.toggle('calm', p >= .999 && y > journey);
  const all = Math.max(1, document.documentElement.scrollHeight - innerHeight), q = Math.min(1, y/all);
  mhead.style.top = (q*100) + '%';
  const sp = Math.min(1, Math.abs(vel)/22); meteor.style.setProperty('--sp', sp.toFixed(3)); meteor.classList.toggle('slide', sp > .06);   

  if (!bare) renderer.render(scene, camera);
  if (!reduce && !document.hidden) requestAnimationFrame(frame); else running = false;
}
let running = true; ready = true;
requestAnimationFrame(frame);
document.addEventListener('visibilitychange', () => { if (!document.hidden && !running && !reduce) { running = true; last = performance.now(); requestAnimationFrame(frame); } });
addEventListener('bbc-theme', e => { if (introDone) applyTheme(e.detail); });
applyTheme(document.documentElement.dataset.theme || 'white');
if (INTRO) { renderer.setClearColor(0x050505, 1); scene.fog.color.setHex(0x050505); clay.color.setHex(0xc8c8c8); chrome.color.setHex(0xf0f0f0); }
